import React, { useState } from "react";

import { Button, Group, Loader, Modal, TextInput } from "@mantine/core";
import PlacesAutocomplete, { geocodeByPlaceId, getLatLng } from 'react-places-autocomplete';
import SimpleMap from "./simple_map";

const LocationDialog = ({ onChange, data, onCancel, onSubmit }) => {
    const [searchLocation, setSearchLocation] = useState("");

    const handleSelectPlace = (title, place_id) => {
        geocodeByPlaceId(place_id, {})
        .then(async results => {
            return ({result: results[0], latLng: await getLatLng(results[0])})
        })
        .then(({latLng, result}) => {
            let place = {...result, ...latLng, title, place_id}  
            setSearchLocation("")
            onChange && onChange({place})
        })
        .catch(error => { setSearchLocation("") });
    }

    return <Modal
        onClose={onCancel}
        opened={Boolean(data)}
        size="xl"
    >
        <div>
            <PlacesAutocomplete
                value={searchLocation}
                onChange={setSearchLocation}
                onSelect={handleSelectPlace}
                shouldFetchSuggestions={searchLocation && searchLocation.length > 3}
                searchOptions={{
                    
                }}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div>
                    <TextInput
                        {
                            ...getInputProps({
                                placeholder: 'Buscar localização...',
                                helperText: "Digite o nome do local",
                            })
                        }
                    />

                    <div className="autocomplete-dropdown-container">
                    {loading && <Loader />}
                    {suggestions
                    .map(suggestion => {
                        const className = suggestion.active
                        ? 'suggestion-item--active'
                        : 'suggestion-item';
                        // inline style for demonstration purpose
                        const style = suggestion.active
                        ? { backgroundColor: '#fafafa', fontSize: 14, borderBottom: '1px solid #DADADA', padding: '10px', cursor: 'pointer' }
                        : { backgroundColor: '#ffffff', fontSize: 14, borderBottom: '1px solid #DADADA', padding: '10px', cursor: 'pointer' };
                        return (
                        <div
                            {...getSuggestionItemProps(suggestion, {
                            className,
                            style,
                            })}
                        >
                            <span>{suggestion.description}</span>
                        </div>
                        );
                    })}
                    </div>
                </div>
                )}
            </PlacesAutocomplete>
            {
                data && data.place && data.place.geometry &&
                <div style={{padding: 20, background: '#FCFCFC', fontSize: 14}}>
                    <div><strong>LOCAL:</strong> {data.place.title}</div>
                    <div><strong>ENDEREÇO:</strong> {data.place.formatted_address}</div>
                </div>
            }
        </div>
        <Group dir="center">
            <div style={{width: '100%', height: 400}}>
                {
                    data?.place?.geometry?.location &&
                    <SimpleMap
                        // googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDV8uT7yErfIloYQBp_PXlEyJnTBWJ3Hpk"
                        // loadingElement={<Loader />}
                        origin={data.place.geometry.location}
                        height={300}
                    />
                }
                </div>
        </Group>
        <Group position="right">
            <Button color="orange" variant="light" onClick={onCancel}>Cancelar</Button>
            <Button color="orange" onClick={onSubmit} disabled={!data?.place?.geometry?.location}>Selecionar</Button>
        </Group>
    </Modal>
}

// export default GoogleApiWrapper({
//     apiKey: "AIzaSyDV8uT7yErfIloYQBp_PXlEyJnTBWJ3Hpk",
//     LoadingContainer: Loader,
// })(LocationDialog)
export default (LocationDialog)